/** What a building's supply closet holds, by the category its cost is counted under. Kitchen is
    its own so the kitchen's spend (its food and its supplies) can be told apart. */
export const SUPPLY_CATEGORIES = [
  "kitchen",
  "cleaning",
  "paper-goods",
  "disposables",
  "personal-care",
  "incontinence",
  "medical",
  "office",
  "other",
] as const;
export type SupplyCategory = (typeof SUPPLY_CATEGORIES)[number];

export const SUPPLY_CATEGORY_LABEL: Record<SupplyCategory, string> = {
  kitchen: "Kitchen",
  cleaning: "Cleaning",
  "paper-goods": "Paper goods",
  disposables: "Disposables",
  "personal-care": "Personal care & toiletries",
  incontinence: "Incontinence care",
  medical: "Medical & first aid",
  office: "Office supplies",
  other: "Other",
};

export const isSupplyCategory = (value: string): value is SupplyCategory =>
  (SUPPLY_CATEGORIES as readonly string[]).includes(value);
